<ngx-charts-chart
  [view]="[width, height]"
  [showLegend]="legend"
  [legendOptions]="legendOptions"
  [activeEntries]="activeEntries"
  [animations]="animations"
  (legendLabelActivate)="onActivate($event, undefined, true)"
  (legendLabelDeactivate)="onDeactivate($event, undefined, true)"
  (legendLabelClick)="onClick($event)"
>
  <svg:g [attr.transform]="transform" class="bar-chart chart">
    <svg:g
      ngx-charts-grid-panel-series
      [xScale]="groupScale"
      [yScale]="valueScale"
      [data]="results"
      [dims]="dims"
      [orient]="barOrientationRef.Vertical"
    ></svg:g>
    <svg:g
      ngx-charts-x-axis
      *ngIf="xAxis"
      [xScale]="groupScale"
      [dims]="dims"
      [showLabel]="showXAxisLabel"
      [labelText]="xAxisLabel"
      [trimTicks]="trimXAxisTicks"
      [rotateTicks]="rotateXAxisTicks"
      [maxTickLength]="maxXAxisTickLength"
      [tickFormatting]="xAxisTickFormatting"
      [ticks]="xAxisTicks"
      [xAxisOffset]="dataLabelMaxHeight.negative"
      [wrapTicks]="wrapTicks"
      (dimensionsChanged)="updateXAxisHeight($event)"
    ></svg:g>
    <svg:g
      ngx-charts-y-axis
      *ngIf="yAxis"
      [yScale]="valueScale"
      [dims]="dims"
      [showGridLines]="showGridLines"
      [showLabel]="showYAxisLabel"
      [labelText]="yAxisLabel"
      [trimTicks]="trimYAxisTicks"
      [maxTickLength]="maxYAxisTickLength"
      [tickFormatting]="yAxisTickFormatting"
      [ticks]="yAxisTicks"
      [wrapTicks]="wrapTicks"
      (dimensionsChanged)="updateYAxisWidth($event)"
    ></svg:g>
    <svg:g *ngIf="!isSSR">
      <svg:g
        ngx-charts-series-vertical
        *ngFor="let group of results; let index = index; trackBy: trackBy"
        [@animationState]="'active'"
        [attr.transform]="groupTransform(group)"
        [activeEntries]="activeEntries"
        [xScale]="innerScale"
        [yScale]="valueScale"
        [colors]="colors"
        [series]="group.series"
        [dims]="dims"
        [gradient]="gradient"
        [tooltipDisabled]="tooltipDisabled"
        [tooltipTemplate]="tooltipTemplate"
        [showDataLabel]="showDataLabel"
        [dataLabelFormatting]="dataLabelFormatting"
        [seriesName]="group.name"
        [roundEdges]="roundEdges"
        [animations]="animations"
        [noBarWhenZero]="noBarWhenZero"
        (select)="onClick($event, group)"
        (activate)="onActivate($event, group)"
        (deactivate)="onDeactivate($event, group)"
        (dataLabelHeightChanged)="onDataLabelMaxHeightChanged($event, index)"
      />
    </svg:g>
    <svg:g *ngIf="isSSR">
      <svg:g
        ngx-charts-series-vertical
        *ngFor="let group of results; let index = index; trackBy: trackBy"
        [attr.transform]="groupTransform(group)"
        [activeEntries]="activeEntries"
        [xScale]="innerScale"
        [yScale]="valueScale"
        [colors]="colors"
        [series]="group.series"
        [dims]="dims"
        [gradient]="gradient"
        [tooltipDisabled]="tooltipDisabled"
        [tooltipTemplate]="tooltipTemplate"
        [showDataLabel]="showDataLabel"
        [dataLabelFormatting]="dataLabelFormatting"
        [seriesName]="group.name"
        [roundEdges]="roundEdges"
        [animations]="animations"
        [noBarWhenZero]="noBarWhenZero"
        (select)="onClick($event, group)"
        (activate)="onActivate($event, group)"
        (deactivate)="onDeactivate($event, group)"
        (dataLabelHeightChanged)="onDataLabelMaxHeightChanged($event, index)"
      />
    </svg:g>

    <svg:g *ngIf="referenceLines?.length && dims && valueScale">
      <svg:g *ngFor="let refLine of referenceLines" class="ref-line-group">
        <svg:line
          class="ref-line"
          [attr.x1]="0"
          [attr.y1]="valueScale(refLine.value)"
          [attr.x2]="dims.width"
          [attr.y2]="valueScale(refLine.value)"
          [attr.stroke]="refLine.color || '#e44'"
        />
        <svg:rect
          class="ref-line-hit-area"
          [attr.x]="0"
          [attr.y]="valueScale(refLine.value) - 6"
          [attr.width]="dims.width"
          [attr.height]="12"
          fill="transparent"
          (mouseenter)="onRefLineMouseEnter($event, refLine)"
          (mousemove)="onRefLineMouseMove($event)"
          (mouseleave)="onRefLineMouseLeave()"
        />
      </svg:g>
    </svg:g>
  </svg:g>
</ngx-charts-chart>

<div
  *ngIf="activeRefLine"
  class="ref-line-tooltip"
  [style.left.px]="tooltipX + 14"
  [style.top.px]="tooltipY - 44"
>
  <span class="ref-line-tooltip-label">{{ activeRefLine.label }}</span>
  <span class="ref-line-tooltip-value">{{ activeRefLine.value }}</span>
</div>
